// extracted by mini-css-extract-plugin
module.exports = {"NavigationItems":"NavigationItems_NavigationItems__PWW_6","Chart":"NavigationItems_Chart__3Ihkd","ChartName":"NavigationItems_ChartName__1UDsX"};